export default {
  app: true,
  show: true,
  inset: true,
  padless: true,
  fixed: false,
  absolute: true,
};
